import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { api } from '@/utils/constants'

import { UpdatePasswordPayload } from '@/types/user'

export const updatePassword = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.user.UPDATE_PASSWORD}`,
    async ({ request }) => {
        const payload = await request.json()

        const payloadParsed = UpdatePasswordPayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        return HttpResponse.json()
    },
)
